import { velocityPerSecond } from '@motionone/utils';

const sampleT = 5; // ms
function calcGeneratorVelocity(resolveValue, t, current) {
    const prevT = Math.max(t - sampleT, 0);
    return velocityPerSecond(current - resolveValue(prevT), t - prevT);
}

export { calcGeneratorVelocity };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@motionone/generators/dist/utils/velocity.es.js
// module id = zpdJ
// module chunks = 0